import GuidedCampaignCreation from './components/GuidedCampaignCreation';
import './assets/GuidedCampaignCreation.css';
import {connect} from 'react-redux';
import withRouter from 'react-router-dom/withRouter';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import values from 'lodash/values';
import isEmptyObject from 'lodash/isEmpty';
import {
  isEngagementValid,
  isEmpty,
  dayIsInPast,
  alphabeticallySort,
  isCoverValid,
  isConclusionValid
} from '../../shared/utils';

import { getActiveAgencyUser } from '../../shared/redux/selectors';

import {
  createAgency,
  createBrand,
  createEngagement,
  updateEngagement,
  deleteEngagement,
  createCampaign,
  loadCampaign,
  loadAgencies,
  loadBrands,
  loadDCMTagsForCampaign,
  loadBrandsForAgency,
  updateCampaign,
  loadEngagementsForCampaign,
  addOptionToEngagement,
  updateEngagementOption,
  deleteEngagementOption,
  updateEngagementSortOrder,
  updateBrand,
  submitCampaign,
  updateUser,
  updateEngagmentOptions,
  syncCampaignDCMTags,
  syncEngagementDCMTags,
  loadTagVendors
} from '../../shared/redux/entities/actions';

import {
  loadAccountHistory
} from '../../shared/redux/accounting/actions';


function getBrandsForAgency(state,agencyId){
  const brands = values(state.entities.companies)
    .filter((c) => c.isBrand)
    .filter((b) => b.active)
    // .filter((b) => b.logoURL && b.logoURL.length > 0)

  if(agencyId){
    return brands.filter((b) => b.agencyId === agencyId);
  } else {
    return brands;
  }
}

function getEngagementsForCampaign(state,campaignId){
  if(campaignId){
    return values(state.entities.engagements)
      .filter((e) => e.campaignId === campaignId)
      .sort((a,b) => a.ordinal - b.ordinal);

  } else {
    return [];
  }
}

function getInvalidEngagementIndexes(state,campaignId){
  const engagements = getEngagementsForCampaign(state,campaignId);
  return engagements.reduce((invalids,e,index) => {
    if(!isEngagementValid(e)){
      return invalids.concat(index)
    } else{
      return invalids
    }
  },[]);
}

function getMissingFields(state,campaignId){
  const activeCampaign = get(state,['entities','campaigns',campaignId],{}),
    activeBrand = get(state,['entities','companies',activeCampaign.companyId],null),
    missingFields = [];

  if(campaignId === 'new'){
    return [];
  }

  if(!activeCampaign){
    return [];
  }

  if(isEmpty(activeCampaign.name)){
    missingFields.push('Name');
  }

  if(activeCampaign.lifetimeBudget < 50){
    missingFields.push('Budget');
  }

  if(isEmpty(activeCampaign.companyId) || (activeBrand && isEmpty(activeBrand.logoURL)) || (activeBrand && isEmpty(activeBrand.primaryColor))){
    missingFields.push('Brand');
  }

  if(isEmpty(activeCampaign.feedImageURL)){
    missingFields.push('Cover tile image');
  }

  if(!activeCampaign.launchDate){
    missingFields.push('Start Date');
  }

  if(dayIsInPast(activeCampaign.endDate)){
    missingFields.push('End Date');
  }

  if(!isConclusionValid(activeCampaign)){
    missingFields.push('Conclusion');
  }

  return missingFields;
}

function getNextOrdinal(state,campaignId){
  const engagements = getEngagementsForCampaign(state,campaignId);

  if(engagements.length === 0){
    return 0;
  } else {
    return engagements[engagements.length - 1].ordinal + 1;
  }
}

function areAllRequiredFieldsFilled(state,campaignId){
  const activeCampaign = get(state,['entities','campaigns',campaignId],null);

  if(!activeCampaign) return false;

  return activeCampaign.companyId
    && (activeCampaign.feedImageURL || '').length > 0
    && activeCampaign.completionText && activeCampaign.completionText.replace(/<\/?[^>]+(>|$)/g, "").trim().length > 0
    && activeCampaign.name.length > 0
    && activeCampaign.launchDate
    && !dayIsInPast(activeCampaign.endDate)
    && activeCampaign.lifetimeBudget >= 50
    && isConclusionValid(activeCampaign)
}

function getIsBudgetLocked(state,campaignId){
  const paymentMethodId = get(state,['entities','campaigns',campaignId,'paymentMethodId'],null),
    paymentMethodKind = get(state,['entities','paymentMethods',paymentMethodId,'kind']);

  return paymentMethodKind === 'adjoy' || paymentMethodKind === 'invoice';

}

function getAgencies(state){
  return values(state.entities.agencies)
    .sort((a,b) => alphabeticallySort(a.name,b.name));
}

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    activeCampaign = get(state,['entities','campaigns',campaignId],{}),
    activeUser = getActiveAgencyUser(state);

  return {
    campaignId:campaignId,
    isCreate:campaignId === 'new',
    isActiveUserProvider:get(activeUser,['isProvider'],true),
    isCampaignEditable:campaignId === 'new' || activeCampaign.status === 'draft',
    isActiveUserImpersonating:get(state,['session','isImpersonating'],false),
    isBudgetLocked:getIsBudgetLocked(state,campaignId),
    needsActiveUser:activeUser === null,
    agencies:getAgencies(state),
    brands:getBrandsForAgency(state,activeCampaign.agencyId),
    activeUser:activeUser,
    activeCampaign:activeCampaign,
    activeAgency:get(state,['entities','agencies',activeCampaign.agencyId],{}),
    activeBrand:get(state,['entities','companies',activeCampaign.companyId],{}),
    activeEngagements:getEngagementsForCampaign(state,activeCampaign.id),
    nextOrdinal:getNextOrdinal(state,activeCampaign.id),
    invalidEngagementIndexes:getInvalidEngagementIndexes(state,activeCampaign.id),
    allRequiredFieldsAreFilled:areAllRequiredFieldsFilled(state,activeCampaign.id),
    missingFields:getMissingFields(state,campaignId),
    activeUserHasSeenTutorial: isEmptyObject(activeUser) ? true : get(activeUser,['hasSeenCampaignIntro'],false),
    activeAgencyAccountingBalance:get(state,['accounting','accounts',activeCampaign.agencyId,'balance'],0),
    tagVendors:state.entities.tagVendors,
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadAgencies,
    loadBrands,
    loadBrandsForAgency,
    createBrand,
    createCampaign,
    createEngagement,
    loadCampaign,
    updateCampaign,
    updateEngagement,
    loadEngagementsForCampaign,
    updateEngagementSortOrder,
    createAgency,
    updateEngagementOption,
    addOptionToEngagement,
    deleteEngagementOption,
    deleteEngagement,
    submitCampaign,
    updateUser,
    updateBrand,
    updateEngagmentOptions,
    loadAccountHistory,
    syncCampaignDCMTags,
    syncEngagementDCMTags,
    loadTagVendors
  },dispatch);
}


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(GuidedCampaignCreation));



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/index.js